import React, { Component } from "react";
import Textbox from "@acadia-ui/textbox";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import BookFiltersStores from "../../../Flux/Stores/BookFiltersStore";
class CurrencyV2 extends Component {
	constructor(props) {
		super(props);
	}

	onChangeFunc = (value) => {
		this.props.onCurrencyChange(value.currentTarget.value, this.props.name, this.props.dataConfig, this.props.id);
	};

	render() {
		const currencySymbol = BookFiltersStores.getCurrencySymbol();
		return (
			<Textbox
				disabled={this.props.readOnly}
				type={"currency"}
				name={this.props.name}
				className={this.props.className}
				required={this.props.required}
				id={this.props.id.toString()}
				data-config={this.props.dataConfig}
				value={this.props.value}
				placeholder={this.props.placeholderText}
				onChange={this.onChangeFunc}
				icon={currencySymbol !== null ? currencySymbol : ""}
			>
				{this.props.label}
				{this.props.fieldDescription && (
					<Tooltip className="field-description-tooltip" title={this.props.fieldDescription} position={TOOLTIP_POSITION.BOTTOM}>
						<i className="icon-info" />
					</Tooltip>
				)}
			</Textbox>
		);
	}
}

/* This should come in handy */
CurrencyV2.defaultProps = {};

export default CurrencyV2;
